import { render, staticRenderFns } from "./page-login-video-stream-alternative-hint.vue?vue&type=template&id=2c8a72db&"
import script from "./page-login-video-stream-alternative-hint.vue?vue&type=script&lang=js&"
export * from "./page-login-video-stream-alternative-hint.vue?vue&type=script&lang=js&"
import style0 from "./page-login-video-stream-alternative-hint.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports